// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { SelectedRows } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line:no-forward-ref
  useExisting: forwardRef(() => SelectableFieldComponent),
  multi: true
};

@Component({
  selector: 'app-selectable-field',
  templateUrl: './selectable-field.component.html',
  styleUrls: ['./selectable-field.component.scss'],
  providers: [VALUE_ACCESSOR]
})
export class SelectableFieldComponent implements ControlValueAccessor, OnInit {
  value: any;
  showSelectabletable = false;
  accountsTableColumns = [{ name: 'Select an Organization of the list', prop: 'name' }];

  @Input() label = 'Selectable Field';

  propagateChange: Function = () => null;

  writeValue(obj: any): void {
    this.value = obj ? obj : '';
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {}

  constructor() {}

  ngOnInit(): void {}

  onSelectAccount(rows: SelectedRows) {
    this.value = rows.selected[0];
    this.toggleSelectableTable();
    this.propagateChange(this.value);
  }
  toggleSelectableTable() {
    this.showSelectabletable = !this.showSelectabletable;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/shared/selectable-field/selectable-field.component.ts